import { ContinueMessage, HeaderMessage, Message } from './styles';
import { Button } from '@/components/Button/Button';
import { Box } from '@/components/Box/Box';
import { Notification } from '@/components/Notification/Notification';
import { useTranslation } from 'react-i18next';

type ResetRequestType = {
  confirmationStep: boolean;
  error: string;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onSuccess: () => void;
};

export const ResetRequest = ({
  confirmationStep,
  isLoading,
  error,
  onSuccess,
  onCancel,
  onConfirm,
}: ResetRequestType) => {
  const { t } = useTranslation(['login']);

  return (
    <>
      {confirmationStep ? (
        <Box display='flex' flexDirection='column' rowGap='32px'>
          <Box display='flex' flexDirection='column'>
            <HeaderMessage>Request Account Reset</HeaderMessage>
            {error && (
              <Notification variant='error' marginBottom='24px'>
                {error}
              </Notification>
            )}
            <Message>{t('login:resetRequestModalMessage')}</Message>
          </Box>
          <ContinueMessage>Do you want to continue?</ContinueMessage>
          <Box display='flex' flexDirection='row' columnGap='20px'>
            <Button variant='secondary' onClick={onCancel}>
              No
            </Button>
            <Button variant='primary' onClick={onConfirm} isLoading={isLoading}>
              Yes
            </Button>
          </Box>
        </Box>
      ) : (
        <Box display='flex' flexDirection='column'>
          <HeaderMessage>Account Request Reset is Sent</HeaderMessage>
          <Box display='flex' flexDirection='column' rowGap='32px'>
            <Message>{t('login:requestSendModalMessage')}</Message>
            <Button onClick={onSuccess}>Ok</Button>
          </Box>
        </Box>
      )}
    </>
  );
};
